<div class="brand-bar">
  <!--<img src="assets/images/eprove-strategies-navbar-logo.svg" alt="eprove&trade; strategies">-->
</div>
<div class="left-nav-content">
  <div>
    <span class="logged-in-as">Logged in as</span>
    <a class="logout-link" (click)="onLogout()">Logout</a>
  </div>
  <div class="user-name">
    <span>{{user.firstName}} </span>
    <span>{{user.lastName}}</span>
  </div>
  <div class="strategy-info">
    <a [class.disabled]="hasAccessToSingleInstitution" (click)="onNavigateToInstitutionSelector()">
      <span class="institution-details">{{customer.name}}</span>
      <span>{{institutionLocation.city | titlecase}}, </span>
      <span>{{institutionLocation.state | titlecase}}</span>
    </a>
  </div>

  <div class="nav-menu">
    <div class="nav-item">
      <a (click)="onNavigateToStrategies()">
        <img src="assets/images/ae-whiteboard-icon-dark.svg"/>
        <span class="link-text">My Plans</span>
      </a>
    </div>
    <div class="nav-item" *ngIf="canSeeUserMgmtLink">
      <a (click)="onNavigateToManageUsers()">
        <img src="assets/images/manage-users.svg"/>
          <span class="link-text">Manage Users</span>
      </a>
    </div>
    <div class="nav-item">
      <a (click)="onNavigateToResources()">
        <img src="assets/images/resources.svg"/>
        <span class="link-text">Resources</span>
      </a>
    </div>
  </div>

  <div class="brand-bottom">
      <div class="row">
        <div class="side-logo">
          <img src="assets/images/full-cognia-logo-black.svg" alt="Cognia&trade; strategies">
        </div>
      </div>
      <div class="info-container">
        <div class="row">
          &copy;{{date| date:'yyyy'}} Cognia, Inc.
        </div>
        <div class="row">
          <a class="info-text brand-links" target="_blank" href="https://www.cognia.org/">cognia.org</a>
        </div>
        <div class="row">
          <a class="info-text brand-links" target="_blank" href="https://www.cognia.org/user-terms/">Terms and Conditions</a>
        </div>
        <div class="row">
          <a class="info-text brand-links" target="_blank" [href]="privacyPolicyUrl">Privacy Policy</a>
        </div>
      </div>
  </div>
</div>
